import React from "react"
import { observer } from "mobx-react"
import { useBasketStore, useRapidDeliveryStore } from "../../../store/hooks/useStore"
import { Box, Text } from "../../../vanilla"
import { cartDrawerUnavailableCallout, cartDrawerUnavailableItem, cartItemDrawer } from "../../../components/header/cart-drawer/styles.css"
import { PreviouslyRemovedItem } from "../../../types/store/basket"
import { CartItem } from "../../../components/cart-item"

export const UnavailableCartItems = observer(({inDrawer = false}) => {
    const { isRapidDeliveryBooked } = useRapidDeliveryStore()
    const { previouslyRemovedItems } = useBasketStore()

    return (
        <Box
            border="1px"
            className={cartDrawerUnavailableItem}
        >
            <Box
                paddingX="16px"
                paddingY="8px"
                className={cartDrawerUnavailableCallout}
                data-test-selector="unavailable-cart-items-callout"
            >
                <Text>
                    {previouslyRemovedItems?.length} item{previouslyRemovedItems?.length > 1 ? 's' : ''}
                    {previouslyRemovedItems?.length > 1 ? ' are' : ' is'}{isRapidDeliveryBooked ? ` not available for Rapid Delivery.` : ' no longer available.'}
                </Text>
            </Box>
            {previouslyRemovedItems?.map(
                (productItem: PreviouslyRemovedItem, idx: number) =>
                    productItem.pid ? (
                        <CartItem
                            inDrawer={inDrawer}
                            id={productItem.pid}
                            className={cartItemDrawer + ' ' + cartDrawerUnavailableItem}
                            style={idx === previouslyRemovedItems.length - 1 ? { borderBottom: 'none' } : { borderColor: 'inherit' }}
                            isUnavailable={true}
                        />
                    ) : null
            )}
        </Box>
    )
})